import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { discountDefSchema, variableSchema } from './entities';

export const types = {
  DELETE_DISCOUNT_ERROR: 'discounts/detailsPage/DELETE_DISCOUNT_ERROR',
  DELETE_DISCOUNT_REQUEST: 'discounts/detailsPage/DELETE_DISCOUNT_REQUEST',
  DELETE_DISCOUNT_SUCCESS: 'discounts/detailsPage/DELETE_DISCOUNT_SUCCESS',

  FORMULA_OPEN_MODAL: 'discounts/detailsPage/FORMULA_OPEN_MODAL',
  FORMULA_CLOSE_MODAL: 'discounts/detailsPage/FORMULA_CLOSE_MODAL',
  FORMULA_COMPILE_REQUEST: 'discounts/detailsPage/FORMULA_COMPILE_REQUEST',
  FORMULA_COMPILE_SUCCESS: 'discounts/detailsPage/FORMULA_COMPILE_SUCCESS',
  FORMULA_COMPILE_ERROR: 'discounts/detailsPage/FORMULA_COMPILE_ERROR',
  FORMULA_UPDATE_REQUEST: 'discounts/detailsPage/FORMULA_UPDATE_REQUEST',
  FORMULA_UPDATE_SUCCESS: 'discounts/detailsPage/FORMULA_UPDATE_SUCCESS',
  FORMULA_UPDATE_ERROR: 'discounts/detailsPage/FORMULA_UPDATE_ERROR',
  FORMULA_RESET_MESSAGE: 'discounts/detailsPage/FORMULA_RESET_MESSAGE',

  RECEIVE_DISCOUNT: 'discounts/detailsPage/RECEIVE_DISCOUNT',

  UPDATE_DISCOUNT_ERROR: 'discounts/detailsPage/UPDATE_DISCOUNT_ERROR',
  UPDATE_DISCOUNT_REQUEST: 'discounts/detailsPage/UPDATE_DISCOUNT_REQUEST',
  UPDATE_DISCOUNT_SUCCESS: 'discounts/detailsPage/UPDATE_DISCOUNT_SUCCESS',

  UPDATE_VARIABLE_ERROR: 'discounts/detailsPage/UPDATE_VARIABLE_ERROR',
  UPDATE_VARIABLE_REQUEST: 'discounts/detailsPage/UPDATE_VARIABLE_REQUEST',
  UPDATE_VARIABLE_SUCCESS: 'discounts/detailsPage/UPDATE_VARIABLE_SUCCESS',
};

export const deleteDiscount = {
  error: notify(
    (error) => ({
      type: types.DELETE_DISCOUNT_ERROR,
      payload: error,
    }),
    'Failed to delete Discount',
  ),
  request: () => ({
    type: types.DELETE_DISCOUNT_REQUEST,
  }),
  success: notify(
    () => ({
      type: types.DELETE_DISCOUNT_SUCCESS,
    }),
    'Successfully deleted Discount',
  ),
};

export const entities = {
  receiveDiscount: ({ discount }) => ({
    type: types.RECEIVE_DISCOUNT,
    payload: normalize(discount, discountDefSchema),
  }),
};

export const formulaEdit = {
  openModal: () => ({
    type: types.FORMULA_OPEN_MODAL,
  }),
  closeModal: () => ({
    type: types.FORMULA_CLOSE_MODAL,
  }),
  compileRequest: ({ formula }) => ({
    type: types.FORMULA_COMPILE_REQUEST,
    payload: { formula },
  }),
  compileSuccess: () => ({
    type: types.FORMULA_COMPILE_SUCCESS,
  }),
  compileError: ({ error }) => ({
    type: types.FORMULA_COMPILE_ERROR,
    payload: { error },
  }),
  updateRequest: ({ formula, revertedFrom }) => ({
    type: types.FORMULA_UPDATE_REQUEST,
    payload: { formula, revertedFrom },
  }),
  updateSuccess: ({ formula }) => ({
    type: types.FORMULA_UPDATE_SUCCESS,
    payload: { formula },
  }),
  updateError: ({ error }) => ({
    type: types.FORMULA_UPDATE_ERROR,
    payload: { error },
  }),
  resetFormulaMessage: () => ({
    type: types.FORMULA_RESET_MESSAGE,
  }),
};

export const updateDiscount = {
  error: notify(
    (error) => ({
      type: types.UPDATE_DISCOUNT_ERROR,
      payload: error,
    }),
    'Failed to save discount',
  ),
  request: ({ discountId, data }) => ({
    type: types.UPDATE_DISCOUNT_REQUEST,
    payload: { discountId, data },
  }),
  success: ({ discount }) => ({
    type: types.UPDATE_DISCOUNT_SUCCESS,
    payload: normalize(discount, discountDefSchema),
  }),
};

export const updateVariable = {
  error: notify(
    (error) => ({
      type: types.UPDATE_VARIABLE_ERROR,
      payload: error,
    }),
    'Failed to save discount input',
  ),
  request: ({ variableId, data }) => ({
    type: types.UPDATE_VARIABLE_REQUEST,
    payload: { variableId, data },
  }),
  success: ({ variable }) => ({
    type: types.UPDATE_VARIABLE_SUCCESS,
    payload: normalize(variable, variableSchema),
  }),
};
